import { html, LitElement } from 'lit-element';
import { aggregateStyles } from '../cssUtils.js';

/**
 * @element ordering-aggregate
 * @prop {Object} model - The model for the pie
 * @prop {Object} aggregate - The aggregate
 */
export class OrderingAggregate extends LitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      aggregate: { type: Array, attribute: false },
    };
  }

  _renderResponses() {
    const { responses, incorrect, averageScore, partiallyCorrect, correct } =
      this.aggregate || {};
    const { markup } = this.model || {};

    return html`
      <span>Responses: ${responses}</span><br />
      <span>Average Score: ${averageScore ? averageScore.toFixed(2) : 0}</span
      ><br />
      <span>Correct: ${correct}</span><br />
      <span>Partially Correct: ${partiallyCorrect}</span><br />
      <span>Incorrect: ${incorrect}</span><br />
      <span>Markup: ${markup}</span><br />
      <br />
    `;
  }

  _renderSelections() {
    const { selections } = this.aggregate || {};

    if (!selections) return html``;

    const categoryKeys = Object.keys(selections);

    return categoryKeys.map(categoryKey => {
      const categorySelections = Object.values(selections[categoryKey]);

      return html`
        <span><strong>For position ${categoryKey}:</strong></span>
        <br />
        ${categorySelections.map(selection => {
          const { value, count } = selection;

          return html`
            <span>
              "${value}" was selected ${count} time${count > 1 ? 's' : ''}
            </span>
            <br />
          `;
        })}
      `;
    });
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html` <style>
        ${aggregateStyles}
      </style>
      <div class="aggregate">
        ${this._renderResponses()} ${this._renderSelections()}
      </div>`;
  }
}

export default OrderingAggregate;
